// Google Analytics utility functions usando react-ga4
import ReactGA from 'react-ga4';

const log = (level, ...args) => {
  if (process.env.NODE_ENV !== 'production') {
    console[level](...args);
  }
};

// Inicializar Google Analytics
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (!measurementId) {
    log('warn', 'Google Analytics Measurement ID no configurado');
    return;
  }

  try {
    ReactGA.initialize(measurementId, {
      gtagOptions: {
        send_page_view: false,
      }
    });
  } catch (err) {
    log('error', 'Error al inicializar Google Analytics');
  }
};

// Track pageview
export const trackPageView = (path, title) => {
  try {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title
    });
  } catch (err) {
    log('warn', 'Error al trackear pageview:', err);
  }
};

export const trackEvent = (eventName, eventParams = {}) => {
  try {
    ReactGA.event(eventName, eventParams);
  } catch (err) {
    log('warn', `Error al trackear evento "${eventName}":`, err);
  }
};

// ─── Eventos específicos ─────────────────────────────

export const trackSearch = (searchTerm, resultsCount) => {
  trackEvent('search', { search_term: searchTerm, results_count: resultsCount });
};

export const trackAutocompleteSelection = (suggestion, searchType) => {
  trackEvent('autocomplete_select', { suggestion, search_type: searchType });
};

export const trackTagClick = (tag, isFiltered) => {
  trackEvent('tag_click', { tag_name: tag, is_filtered: isFiltered });
};

export const trackEasyFilterToggle = (isEnabled) => {
  trackEvent('easy_filter_toggle', { is_enabled: isEnabled });
};

export const trackPostView = (postId, postName) => {
  trackEvent('view_item', { item_id: postId, item_name: postName, content_type: 'post' });
};

export const trackRelatedPostClick = (fromPostId, toPostId, toPostName) => {
  trackEvent('related_post_click', { from_post_id: fromPostId, to_post_id: toPostId, to_post_name: toPostName });
};

export const trackSocialClick = (platform, postId, postName) => {
  trackEvent('social_click', { platform, post_id: postId, post_name: postName });
};

export const trackTagScroll = (direction) => {
  trackEvent('tag_scroll', { direction });
};

export const trackPagination = (pageNumber, totalPages) => {
  trackEvent('pagination', { page_number: pageNumber, total_pages: totalPages });
};

export const trackSearchClear = () => {
  trackEvent('search_clear');
};

export const trackTagClickFromDetail = (tag, postId) => {
  trackEvent('tag_click_from_detail', { tag_name: tag, post_id: postId });
};

export const trackVideoEmbed = (postId, postName) => {
  trackEvent('video_embed_load', { post_id: postId, post_name: postName });
};
